exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ScoringGraph{display:flex;flex-direction:column;align-items:center;justify-content:center}.ScoringGraph,.ScoringGraph .spinner{margin-top:3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/graphs/scoring_graph.scss
// module id = 1277
// module chunks = 0